import { Markdown } from '@features/markdown/components/Markdown';
import { CMSText } from './types';
import Description from './Description';
import GeneralCopy from './GeneralCopy';

type Props = {
  component: CMSText;
};

const Text = ({ component }: Props) => {
  const {
    attributes: { value, cssClass, role },
  } = component;

  if (role === 'description') return <Description component={component} />;

  if (role === 'general') return <GeneralCopy component={component} />;

  return <Markdown className={cssClass} source={value} />;
};

export default Text;
